import React from "react";
import { StatusChip, PersonCell } from "../../../../../component/listing";
import { tokens } from "../../../../../theme";

/**
 * An expense claim as an approver sees it, in one place.
 *
 * The dashboard and the requests queue answer the same question about the same
 * object, and were carrying two copies of these five columns. One had already
 * drifted — the avatars were different colours — which is the usual first sign.
 */
export const CLAIM_STATUS_TONE = {
  pending: "warning",
  approved: "success",
  rejected: "danger",
  reimbursed: "info",
};

export const claimColumns = (money) => [
  {
    key: "employee",
    label: "Employee",
    width: "28%",
    render: (r) => <PersonCell name={r.employeeName} src={r.employee?.profileImage} />,
  },
  { key: "date", label: "Date", cellSx: { color: tokens.textMuted }, render: (r) => r.date },
  { key: "category", label: "Category", render: (r) => r.category },
  { key: "amount", label: "Amount", align: "right", cellSx: { fontWeight: 600 }, render: (r) => money(r.amount) },
  {
    key: "status",
    label: "Status",
    render: (r) => <StatusChip label={r.status} tone={CLAIM_STATUS_TONE[r.status]} />,
  },
];
